// extracted by mini-css-extract-plugin
export default {"contacts":"Feedback_contacts__veUS4"};